import { useState, useEffect } from 'react'
import { Table, Tag, Card, message, Select } from 'antd'

const API_BASE = '/api/geolook-leads'

export default function GeoLookLeads() {
  const [leads, setLeads] = useState([])
  const [loading, setLoading] = useState(true)
  const [total, setTotal] = useState(0)
  const [page, setPage] = useState(1)
  const [statusFilter, setStatusFilter] = useState('all')

  useEffect(() => {
    loadLeads()
  }, [page, statusFilter])

  const loadLeads = async () => {
    setLoading(true)
    try {
      const params = new URLSearchParams({ page: String(page), limit: '50' })
      if (statusFilter !== 'all') params.set('status', statusFilter)

      const res = await fetch(`${API_BASE}?${params}`)
      const json = await res.json()
      if (json.success) {
        setLeads(json.data || [])
        setTotal(json.total || 0)
      } else {
        message.error(json.error || '加载失败')
      }
    } catch (e) {
      message.error('加载失败: ' + e.message)
    }
    setLoading(false)
  }

  const statusColors = {
    pending: 'blue',
    contacted: 'orange',
    completed: 'green',
    invalid: 'default'
  }
  const statusNames = {
    pending: '待处理',
    contacted: '已联系',
    completed: '已完成',
    invalid: '无效'
  }

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 60
    },
    {
      title: '品牌名称',
      dataIndex: 'brand_name',
      key: 'brand_name',
      width: 150
    },
    {
      title: '网址',
      dataIndex: 'website',
      key: 'website',
      width: 200,
      render: (text) => (
        <a href={text} target="_blank" rel="noopener noreferrer" style={{ color: '#722ed1' }}>
          {text}
        </a>
      )
    },
    {
      title: '联系人',
      dataIndex: 'contact_name',
      key: 'contact_name',
      width: 100
    },
    {
      title: '手机号',
      dataIndex: 'phone',
      key: 'phone',
      width: 120
    },
    {
      title: '行业',
      dataIndex: 'industry',
      key: 'industry',
      width: 100,
      render: (text) => text || '-'
    },
    {
      title: '主推关键词',
      dataIndex: 'main_keyword',
      key: 'main_keyword',
      width: 150,
      render: (text) => text || '-'
    },
    {
      title: '客户 AI 问题',
      dataIndex: 'ai_question',
      key: 'ai_question',
      width: 200,
      render: (text) => text || '-'
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      width: 90,
      render: (status) => (
        <Tag color={statusColors[status] || 'default'}>
          {statusNames[status] || status}
        </Tag>
      )
    },
    {
      title: '来源',
      dataIndex: 'source',
      key: 'source',
      width: 100,
      render: (text) => text || '品牌诊断'
    },
    {
      title: '提交时间',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 160
    },
    {
      title: '备注',
      dataIndex: 'remark',
      key: 'remark',
      width: 150,
      render: (text) => text || '-'
    }
  ]

  return (
    <div style={{ padding: 24 }}>
      <Card
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span>🔍 品牌诊断客户线索</span>
            <Select
              value={statusFilter}
              onChange={(v) => { setStatusFilter(v); setPage(1) }}
              style={{ width: 120 }}
              size="small"
            >
              <Select.Option value="all">全部状态</Select.Option>
              <Select.Option value="pending">待处理</Select.Option>
              <Select.Option value="contacted">已联系</Select.Option>
              <Select.Option value="completed">已完成</Select.Option>
              <Select.Option value="invalid">无效</Select.Option>
            </Select>
          </div>
        }
        extra={
          <span style={{ color: '#888', fontSize: 13 }}>
            共 {total} 条记录
          </span>
        }
      >
        <Table
          dataSource={leads}
          columns={columns}
          rowKey="id"
          loading={loading}
          pagination={{
            current: page,
            total,
            pageSize: 50,
            showTotal: (t) => `共 ${t} 条`,
            onChange: (p) => setPage(p)
          }}
          size="small"
          scroll={{ x: 1400 }}
        />
      </Card>
    </div>
  )
}
